module.exports = __webpack_public_path__ + "img/scene5-14.a93fc481.jpg";